import OtpComponent from './OtpComponent';
export default OtpComponent;
